import config from 'config';

export const SESSION_RECORDER_ENABLED = config.environment === 'uat';
